import React from 'react'
import './Experience.css';
import {BsPatchCheckFill} from 'react-icons/bs'

const Experience = () => {
  return (
    <section id='experience'>
      <h5>Skills I Have</h5>
      <h2>My Experience</h2>
      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Web Developement</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsPatchCheckFill className='experience_detail_icon' />
              <div>
                <h4>HTML</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience_detail_icon' />
              <div>
              <h4>CSS</h4>
              <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience_detail_icon' />
             <div>
             <h4>Javascript</h4>
              <small className='text-light'>Intermediate</small>
             </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience_detail_icon' />
                  <div>
                  <h4>React Js</h4>
              <small className='text-light'>Intermediate</small>
                  </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className="experience_detail_icon"/>
              <div>
              <h4>BootStrap and Tailwind</h4>
              <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className="experience_detail_icon"/>
              <div>
              <h4>Figma and Spline</h4>
              <small className='text-light'>Intermediate</small>
              </div>
            </article>
          </div>
        </div>
        <div className="experience__backend">
        <h3>Other Skills</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsPatchCheckFill className="experience_detail_icon"/>
              <div>
                <h4>Python</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className="experience_detail_icon"/>
              <div>
                <h4>C</h4>
                <small className='text-light'>Advanced</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience_detail_icon'/>
              <div>
                <h4>Ethical Hacking</h4>
                <small className='text-light'>Beginner</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience_detail_icon'/>
              <div>
                <h4>C++</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className='experience__det ails'>
              <BsPatchCheckFill className='experience_detail_icon'/>
              <div>
              <h4>MatLab and Data Analysis</h4>
              <small className='text-light'>Beginner</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience